import { Toolbar } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledMuiToolbar = styled(Toolbar)`
  justify-content: center;
  width: 100%;
  background-color: #fff;
  padding: 16px;
`;
